import { Link } from 'react-router-dom';
import { stories } from '@/mocks/stories';
import Tag from '@/components/base/Tag';

const stats = [
  { value: '42', label: '追踪中事件', icon: 'ri-radar-line' },
  { value: '372', label: '收录档案', icon: 'ri-folder-history-line' },
  { value: '218', label: '真伪鉴定', icon: 'ri-shield-check-line' },
];

const tracking = stories.filter((item) => item.status === '追踪中').slice(0, 3);

export default function HeroSection() {
  return (
    <section className="relative overflow-hidden bg-background-100">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary-100" />
      <div className="pointer-events-none absolute -bottom-28 left-10 h-64 w-64 rounded-full bg-accent-100" />

      <div className="relative mx-auto w-full px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <div className="flex flex-wrap items-center gap-2">
              <Tag tone="primary">
                <i className="ri-flashlight-line" />
                今日 06:20 更新
              </Tag>
              <Tag tone="secondary">线索已交叉核实</Tag>
            </div>

            <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
              西瓜瓜田
              <span className="mt-3 block text-xl font-bold text-primary-700 md:text-2xl">
                娱乐吃瓜线索追踪站
              </span>
            </h1>

            <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-700">
              顺着一条爆料顺藤摸瓜，盯住相关小号，再把男方、女方与当事人的口径摆到一起。我们不急着替你下结论，只帮你分清这场瓜里，谁在认真回应，谁在借势表演。
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <Link
                to="/#hot"
                className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                开始追今天的瓜
              </Link>
              <Link
                to="/#guide"
                className="cursor-pointer whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-6 py-3 text-sm font-medium text-secondary-800 transition-colors hover:bg-secondary-100"
              >
                先看吃瓜方法论
              </Link>
            </div>

            <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-background-300 pt-6">
              {stats.map((item) => (
                <div key={item.label}>
                  <dt className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className={item.icon} />
                    {item.label}
                  </dt>
                  <dd className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                    {item.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-5">
            <article className="overflow-hidden rounded-lg border border-background-300 bg-background-50">
              <div className="relative h-44 w-full overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=flat%20vector%20editorial%20illustration%20of%20a%20sliced%20watermelon%20acting%20as%20a%20radar%20screen%20with%20orbiting%20markers%20and%20small%20paper%20notes%2C%20warm%20cream%20paper%20background%2C%20tomato%20red%20amber%20gold%20and%20deep%20teal%20palette%2C%20subtle%20grain%20texture%2C%20minimal%20geometric%20shapes%2C%20no%20text&width=900&height=600&seq=xigua-hero-visual&orientation=landscape"
                  alt="西瓜瓜田正在追踪的娱乐线索示意图"
                  className="h-full w-full object-cover object-top"
                />
                <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-full bg-background-50/95 px-3 py-1 text-xs font-medium text-primary-700">
                  <i className="ri-pushpin-2-line" />
                  正在追踪
                </span>
              </div>
              <div className="p-5">
                <h2 className="font-heading text-lg font-bold text-foreground-950">今天最值得盯的三条线</h2>
                <ul className="mt-4 space-y-3">
                  {tracking.map((item) => (
                    <li key={item.id}>
                      <Link
                        to={`/melon/${item.id}`}
                        className="group flex items-start gap-3 cursor-pointer rounded-md p-2 transition-colors hover:bg-background-100"
                      >
                        <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-500 text-xs font-bold text-accent-950">
                          {item.heat > 9000 ? '热' : '新'}
                        </span>
                        <span className="min-w-0">
                          <span className="line-clamp-2 block text-sm font-medium text-foreground-800 group-hover:text-primary-700">
                            {item.title}
                          </span>
                          <span className="mt-1 block text-xs text-foreground-500">
                            {item.category} · {item.readTime}
                          </span>
                        </span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}